
      import { QRTP } from '@folkjs/labs/QRTP-A';
      import '@folkjs/labs/BraceLabel';

      // Make QRTP available globally for debugging
      window.QRTP = QRTP;

      // Core elements and state
      let videoStream = null;
      let scanInterval = null;
      let cameraActive = false;
      let qrProtocol;

      // Initialize after DOM is loaded
      document.addEventListener('DOMContentLoaded', initApp);

      function initApp() {
        // Initialize protocol
        qrProtocol = new QRTP();

        // Get DOM elements
        const elements = {
          txData: document.getElementById('txData'),
          qrcodeContainer: document.getElementById('qrcode'),
          video: document.getElementById('video'),
          canvas: document.getElementById('canvas'),
          videoContainer: document.getElementById('videoContainer'),
          cameraOverlay: document.getElementById('cameraOverlay'),
          cameraLabel: document.getElementById('cameraOverlay').querySelector('.camera-label'),
          messageLog: document.getElementById('messageLog'),
          sendingProgressBar: document.getElementById('sendingProgressBar'),
          sendingProgressText: document.getElementById('sendingProgressText'),
          receivingProgressBar: document.getElementById('receivingProgressBar'),
          receivingProgressText: document.getElementById('receivingProgressText'),
          receivedTextDisplay: document.getElementById('receivedTextDisplay'),
          chunkSizeInfo: document.getElementById('chunkSizeInfo'),
        };

        // Setup event handlers
        setupProtocolEvents(elements);
        setupUIEvents(elements);

        // Initialize UI
        elements.chunkSizeInfo.textContent = `Using default chunk size of 100 bytes`;
        updateQRCode('Hello world', elements.qrcodeContainer);

        // Set initial message from textarea
        const initialText = elements.txData.value.trim();
        if (initialText) {
          qrProtocol.setMessage(initialText);
        }
      }

      // Setup QRTP protocol event handlers
      function setupProtocolEvents(elements) {
        qrProtocol.on('chunk', (event) => {
          updateReceivedText(event.payload, false, elements.receivedTextDisplay);
          updateProgress(event.index + 1, event.total, elements.receivingProgressBar, elements.receivingProgressText);
        });

        qrProtocol.on('init', (event) => {
          logMessage(
            'outgoing',
            'info',
            `Data set: ${event.dataLength} bytes, ${event.total} chunks (${event.size} bytes/chunk)`,
            elements.messageLog,
          );
          updateProgress(0, event.total, elements.sendingProgressBar, elements.sendingProgressText);
        });

        qrProtocol.on('ack', (event) => {
          if (event.matched) {
            logMessage('incoming', 'ack', `Acknowledged chunk ${event.index + 1}`, elements.messageLog);
          }
          updateProgress(event.index, event.total, elements.sendingProgressBar, elements.sendingProgressText);
        });

        qrProtocol.on('qrUpdate', (event) => {
          updateQRCode(event.data, elements.qrcodeContainer);
        });

        qrProtocol.on('complete', (event) => {
          if (event && event.payload) {
            logMessage('incoming', 'complete', `Message received successfully!`, elements.messageLog);
            updateReceivedText(event.payload, true, elements.receivedTextDisplay);
          } else {
            logMessage('outgoing', 'complete', `Message sent successfully!`, elements.messageLog);
          }
        });
      }

      // Setup UI event handlers
      function setupUIEvents(elements) {
        // Text input handler
        elements.txData.addEventListener('input', function () {
          const text = elements.txData.value.trim();
          elements.messageLog.innerHTML = '';
          elements.receivedTextDisplay.innerHTML = '';

          qrProtocol.setMessage(text);

          // Only reset the receiving progress
          updateProgress(0, 0, elements.receivingProgressBar, elements.receivingProgressText);
        });

        // Camera toggle handler
        elements.videoContainer.addEventListener('click', function () {
          if (cameraActive) {
            stopCamera(elements);
          } else {
            startCamera(elements);
          }
        });
      }

      // Camera control functions
      function startCamera(elements) {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices
            .getUserMedia({ video: { facingMode: 'user' } })
            .then(function (stream) {
              videoStream = stream;
              elements.video.srcObject = stream;
              elements.video.setAttribute('playsinline', true);
              elements.video.play();

              // Set canvas size on video load
              elements.video.onloadedmetadata = function () {
                elements.canvas.width = elements.video.videoWidth;
                elements.canvas.height = elements.video.videoHeight;
              };

              // Start scanning for QR codes
              scanInterval = setInterval(() => scanQrCode(elements), 100);

              // Update UI
              cameraActive = true;
              elements.videoContainer.classList.add('camera-active');
              elements.cameraLabel.textContent = 'Stop Camera';
            })
            .catch(function (error) {
              console.error('Camera error:', error);
              logMessage('system', 'error', `Camera access error: ${error.message}`, elements.messageLog);
            });
        } else {
          logMessage('system', 'error', 'Camera not supported on this device/browser', elements.messageLog);
        }
      }

      function stopCamera(elements) {
        if (videoStream) {
          videoStream.getTracks().forEach((track) => track.stop());
          videoStream = null;
          logMessage('system', 'info', 'Camera stopped', elements.messageLog);
        }

        if (scanInterval) {
          clearInterval(scanInterval);
          scanInterval = null;
        }

        // Update UI
        cameraActive = false;
        elements.videoContainer.classList.remove('camera-active');
        elements.cameraLabel.textContent = 'Start Camera';
      }

      // QR code scanning function
      function scanQrCode(elements) {
        if (elements.video.readyState === elements.video.HAVE_ENOUGH_DATA) {
          const canvasContext = elements.canvas.getContext('2d');
          elements.canvas.width = elements.video.videoWidth;
          elements.canvas.height = elements.video.videoHeight;

          // Draw video frame to canvas
          canvasContext.drawImage(elements.video, 0, 0, elements.canvas.width, elements.canvas.height);

          // Get image data from canvas
          const imageData = canvasContext.getImageData(0, 0, elements.canvas.width, elements.canvas.height);

          // Scan for QR code
          const code = jsQR(imageData.data, imageData.width, imageData.height, {
            inversionAttempts: 'dontInvert',
          });

          // Process QR code if found
          if (code && code.data) {
            const result = qrProtocol.parseCode(code.data);
            if (result === null) {
              logMessage('system', 'error', `Error processing QR code: ${result}`, elements.messageLog);
            }
          }
        }
      }

      // UI update helper functions
      function updateQRCode(qrData, container) {
        // Clear previous QR code
        container.innerHTML = '';

        // Create a new canvas element
        const canvas = document.createElement('canvas');
        container.appendChild(canvas);

        // Calculate container size to determine QR code size
        const containerWidth = container.clientWidth;

        QRCode.toCanvas(
          canvas,
          qrData,
          {
            width: containerWidth, // Use the container width instead of fixed 400px
            margin: 4,
          },
          function (error) {
            if (error) {
              console.error(error);
              logMessage('system', 'error', `Error generating QR code: ${error.message}`, elements.messageLog);
            }
          },
        );

        // Update text preview of QR data
        const qrDataPreview = document.getElementById('qrDataPreview');
        qrDataPreview.textContent = qrData.length > 20 ? qrData.substring(0, 20) + '...' : qrData;
      }

      function updateProgress(current, total, progressBar, progressText) {
        if (total > 0) {
          const progress = Math.min(100, (current / total) * 100);
          progressText.textContent = `${current}/${total}`;
          progressBar.style.width = `${progress}%`;
        } else {
          progressText.textContent = '0/0';
          progressBar.style.width = '0%';
        }
      }

      function updateReceivedText(chunkData, isComplete, displayElement) {
        if (isComplete) {
          // On complete, show the full message
          displayElement.textContent = chunkData;
        } else {
          // For new chunks, append with highlight
          const highlightSpan = document.createElement('span');
          highlightSpan.className = 'highlight-chunk';
          highlightSpan.textContent = chunkData;
          displayElement.appendChild(highlightSpan);
        }

        // Scroll to the bottom
        displayElement.scrollTop = displayElement.scrollHeight;
      }

      function logMessage(direction, type, message, logElement, data = null) {
        const logEntry = document.createElement('div');
        logEntry.className = `log-entry log-entry-${direction}`;

        // Add specific styling for different message types
        if (['error', 'warning', 'debug', 'hash'].includes(type)) {
          logEntry.className += ` log-entry-${type}`;
        }

        const timestamp = new Date().toLocaleTimeString();

        let html = `<span class="log-timestamp">${timestamp}</span>`;
        html += `<span class="log-direction">${direction.toUpperCase()}</span>`;
        html += `<span class="log-type">[${type}]</span>`;
        html += `<span class="log-message">${message}</span>`;

        if (data && typeof data === 'string') {
          html += `<div class="log-data">${data}</div>`;
        }

        logEntry.innerHTML = html;
        logElement.appendChild(logEntry);

        // Auto-scroll to bottom
        logElement.scrollTop = logElement.scrollHeight;
      }
    